import React from 'react';
import NavLinks from './NavLinks';
import type { User } from '../../../types';

type Props = {
  isOwner?: boolean,
  isAdmin?: boolean,
  isClient?: boolean,
  selectedUser?: User,
  onPayrollGeneratorClick?: Function,
  onMarketingStatsClick?: Function,
}

const NavDropdown = (props: Props): React.ReactElement => {
  const { isOwner, isAdmin, isClient, selectedUser, onPayrollGeneratorClick, onMarketingStatsClick } = props;

  return (
    <div className="nav-item dropdown">
      <button className="btn menu-bars" id="navbarDropdownMenu" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
        <i className="fa fa-bars fa-2x" aria-hidden="true" />
      </button>
      <ul className="dropdown-menu" aria-labelledby="navbarDropdownMenu">
        <NavLinks isAdmin={isAdmin} isOwner={isOwner} isClient={isClient} selectedUser={selectedUser} onPayrollGeneratorClick={onPayrollGeneratorClick} onMarketingStatsClick={onMarketingStatsClick} />
      </ul>
    </div>
  );
};

export default NavDropdown;
